import { ActionPayload, DateRange } from '../../../types';

export const CSR_CHANGE_DATE_RANGE = 'CHANGE_DATE_RANGE';

export const  CSRChangeDateRange: (payload: DateRange) => ActionPayload<DateRange> = (payload) => ({
  type: CSR_CHANGE_DATE_RANGE,
  payload,
});
